import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';

import moment from 'moment';
import 'moment/dist/locale/cs';

export const UiMonthPicker = (props: {
    value: any,
    onChange: (value) => void,
    label: string,
}) => {
    return <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale="cs"
    >
        <DatePicker
            value={moment(props.value)}
            onChange={(value) => props.onChange(value)}
            label={props.label}
            showDaysOutsideCurrentMonth
            className={cmpClass}
            views={['month', 'year']}
        />
    </LocalizationProvider>;
};

const cmpClass = 'ui-week-picker';
